
import React from 'react';
import { mergeStyleSets } from 'office-ui-fabric-react/lib/Styling';
import { Stack } from 'office-ui-fabric-react/lib/Stack';

import Text from '../../common/client/components/Text';

import OverviewTitle from './OverviewTitle';

const OverviewPanel = (props) => {

    const classNames = mergeStyleSets({
        OverviewPanel: {
            border: '1px solid #dddddd',
            padding: 16,
            width: props.panelWidth || 500,
            height: props.panelHeight || 'auto'
        }
    });

    return (
        <Stack className={classNames.OverviewPanel}>
            <OverviewTitle title={props.title} />
            {(props.loaded)
                ? <Stack.Item grow>{props.children}</Stack.Item>
                : <Text>Načítám data...</Text>
            }
        </Stack>
    );
}

export default OverviewPanel;
